import React, { useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import AuthorizeCheckbox from './authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../common/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { validateForm } from './validation';
import {
  dispatchGenerator,
  successCounterInState,
} from '../../../../../../helpers/tickets/SelfService';
import { createTicketNoProduct } from '../../../../../../redux/actions/TicketActions';
import { bodyTicketProductGenerator } from '../../../../../../helpers/tickets/TicketsHelper';
import MotiveTitle from '../mobile/forms-views/MotiveTitle';
import Message from '../../../../../common/Message';

const useStyles = makeStyles(() => ({
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
  },
  button: {
    maxWidth: 200,
    margin: '0 auto',
  },
}));

const reducer = (state, { field, value }) => {
  if (field === 'reset') return value;
  return { ...state, [field]: value };
};

const defineCommentHelper = (name, newValue) =>
  name === 'comment' ? `${newValue.length}/250` : '';

//TODO add logic to self service

const FormBase = ({ ...props }) => {
  const {
    mobile,
    title,
    form,
    initialState,
    data,
    schema,
    formName,
    onState,
    product,
    profile,
    motiveId,
    type,
    motiveTitle,
    motiveSubtitle,
    motiveIcon,
    extraData,
    initialMessage,
  } = props;
  const classes = useStyles({ mobile });
  const reduxDispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [valid, setValid] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);

  const noProductTicketClick = () => {
    const body = {
      oc: product.orderId,
      sku: product.sku,
      ...extraData,
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        comment: '',
      }),
    };
    reduxDispatch(createTicketNoProduct(body));
  };

  useEffect(() => {
    if (Object.entries(data).length > 0) {
      const { name, value: newValue } = data;
      const body = {
        newValue,
        helperText: defineCommentHelper(name, newValue),
      };
      const dispatchBody = dispatchGenerator(state, name, body);
      dispatch(dispatchBody);
    }
    if (Object.entries(state).length > 0 && Object.entries(data).length > 0) {
      validateForm(data, dispatch, schema, state);
    }
  }, [data]);

  useEffect(() => {
    onState(state);
    setValid(successCounterInState(state));
  }, [state]);

  return (
    <Box className={classes.container}>
      {initialMessage && (
        <Message severity="info" message={initialMessage} fullRounded />
      )}
      {mobile && (
        <MotiveTitle
          title={motiveTitle}
          subtitle={motiveSubtitle}
          icon={motiveIcon}
        />
      )}
      <Typography className={classes.title}>{title}</Typography>
      {form}
      <AuthorizeCheckbox
        disabled={!valid}
        idComplement={formName}
        onCheck={(e) => setChecked(e)}
      />
      <LoadingButton
        name={formName}
        variant="contained"
        color="primary"
        text="Enviar autorización"
        className={classes.button}
        disabled={!(valid && checked)}
        onClick={noProductTicketClick}
        loading={ticketNoProductStatus === 'loading'}
      />
    </Box>
  );
};

FormBase.propTypes = {
  mobile: PropTypes.bool,
  title: PropTypes.string,
  motiveId: PropTypes.string,
  form: PropTypes.element,
  initialState: PropTypes.object,
  data: PropTypes.object,
  schema: PropTypes.object,
  formName: PropTypes.string,
  onState: PropTypes.func,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  motiveTitle: PropTypes.string,
  motiveSubtitle: PropTypes.string,
  motiveIcon: PropTypes.string,
  extraData: PropTypes.object,
  initialMessage: PropTypes.string,
};

export default FormBase;
